<template>
  <div class="home-layout">
    <!-- 顶部导航栏 -->
    <HeaderBar
      v-if="currentView !== 'local'"
      :userPower="userPower"
      ref="headerBarRef"
      @openPersonalCenter="handleOpenPersonalCenter"
    />
    <div class="home-content" :class="{ 'no-header': currentView === 'local' }">
      <!-- 左侧导航栏 -->
      <Sidebar
        :is-collapsed="isCollapsed"
        :active-menu="activeMenu"
        @toggleCollapse="toggleCollapse"
        @menuSelect="handleMenuSelect"
      />
      <!-- 右侧内容区 -->
      <main class="main-content" :class="{ shifted: isCollapsed }">
        <section class="content">
          <LocalSpace v-if="currentView === 'local'" />
          <PersonalCenter v-else-if="currentView === 'center'" />
          <BackgroundTask v-else-if="currentView === 'task'" />
          <CardList v-else-if="currentView === 'card'" :type-filter="typeFilter"/>
          <D07ProjectList v-else-if="currentView === 'd07'" />
          <D63ProjectList v-else-if="currentView === 'd63'" />
          <D64ProjectList v-else-if="currentView === 'd64'" />
        </section>
      </main>
    </div>
    
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Sidebar from '@/apps/portal/components/Sidebar.vue'
import HeaderBar from '@/apps/portal/components/HeaderBar.vue'
import defaultAvatar from '@/shared/assets/avatar.jpg'
import LocalSpace from '@/apps/portal/views/storage/LocalSpace.vue'
import PersonalCenter from '@/apps/portal/views/account/PersonalCenter.vue'
import CardList from '@/apps/portal/views/content-tools/CardList.vue'
import BackgroundTask from '@/apps/portal/views/background-task/BackgroundTask.vue'
import D07ProjectList from '@/apps/portal/views/batch-production/video-mix/D07.vue'
import D63ProjectList from '@/apps/portal/views/batch-production/digital-human/D63.vue'
import D64ProjectList from '@/apps/portal/views/batch-production/fast-video-mix/D64.vue'

const isCollapsed = ref(false)
const activeMenu = ref('i_7')
const currentView = ref('center')
const headerBarRef = ref(null);
const typeFilter = ref('')

const toggleCollapse = () => {
  isCollapsed.value = !isCollapsed.value
}

const handleMenuSelect = (index) => {
  activeMenu.value = index
  if (index === 'i_0') {
    currentView.value = 'card'
    typeFilter.value = ''
  }else if (index === 'i_1') {
    currentView.value = 'card'
    typeFilter.value = 'txt'
  }else if (index === 'i_2') {
    currentView.value = 'card'  
    typeFilter.value = 'img'
  }else if (index === 'i_3') {
    currentView.value = 'card'
    typeFilter.value = 'audio'
  }else if (index === 'i_4') {
    currentView.value = 'card'
    typeFilter.value = 'video'
  } else if (index === 'i_5') {
    currentView.value = 'local'
  } else if (index === 'i_7') {
    currentView.value = 'center'
  } else if (index === 'i_8') {
    headerBarRef.value.openInviteGift()
  }else if (index === 'i_10') {
    currentView.value = 'task'
  }else if (index === 'i_16') {
    currentView.value = 'd07'
  }else if (index === 'i_17') {
    currentView.value = 'd63'
  }else if (index === 'i_18') {
    currentView.value = 'd64'
  }
  else {
    currentView.value = 'card'
  }
}

const handleOpenPersonalCenter = () => {
  currentView.value = 'center'
  activeMenu.value = 'i_7'
}

// 用户信息
const userName = ref('')
const userAvatar = ref(defaultAvatar)
const userPower = ref(100)
const getUserInfo = () => {
  const userInfo = localStorage.getItem('userInfo')
  if (userInfo) {
    const parsedInfo = JSON.parse(userInfo)
    userName.value = parsedInfo.name || ''
    userAvatar.value = parsedInfo.headPortrait || defaultAvatar
    userPower.value = parsedInfo.totalAmount || 0
  } else {
    userName.value = '小明'
    userAvatar.value = defaultAvatar
    userPower.value = 220
  }
}

onMounted(() => {
  getUserInfo()
})

</script>

<style scoped>
.home-layout {
  height: 100vh;
  width: 100vw;
}

.home-content{
  position: relative;
  width: 100%;
  height: calc(100vh - 50px);
  display: flex;
}

.home-content.no-header {
  height: 100vh;
}

.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.content {
  flex: 1;
  display: flex;
  padding: 0;
  overflow: hidden;
  position: relative;
}

</style>
